module.exports = __webpack_public_path__ + "static/media/register-bg.4552271d.png";